import * as API  from '@/API'

// 公共参数
const page = 'image correction section -';

//筛选人员列表
export const GET_MEMBER_LIST = 'GET_MEMBER_LIST';
export function getMemberList(){
let params={
	"user_type":[1,2,3,4,5,6]
}
return (dispatch,getState) => {
		API.getMemberListAPI(params).then(res=>{
			dispatch(getMemberListSuccess(res.data));
		})
};
}
function getMemberListSuccess(result){
	 return {
	    type:GET_MEMBER_LIST,
	    payload:{
	    	memberList:result
	    }   
	};
}

// 编辑参数
export const EDIT_PARAM = `${page} edit param`;
export const editParam = (data) => {
	return {
	    type: EDIT_PARAM,
	    payload: data
	}
}

// 任务进行到的位置
export const CURRENT_QUESTION_PAGE = `${page} current question page`;
export const getTaskPosition = (params, callback) => {
	return (dispatch) => {
		API.getTaskPositionAPI(params).then(res => {
			dispatch(getTaskPosSuccess(res.data));
			callback && callback();
		}, (err) => {
			console.log(err)
		});
	}
}
const getTaskPosSuccess = (result) => {
	return {
		type: CURRENT_QUESTION_PAGE,
		payload: {
			positionDetail: result
		}
	}
}

// 插画
export const INSERT_PICTURE = `${page} insert picture`;
export const insertPicture = (param, callback) => {
	return (dispatch) => {
		API.insertPictureAPI(param).then(res => {
			dispatch(insertPictureSuccess(res.data));
			callback && callback();
		}, err => {
			console.log(err)
		})
	}
}
const insertPictureSuccess = (result) => {
	return {
		type: insertPicture,
		payload: result
	}
}

// 修改插画
export const MODIFY_PICTURE = `${page} modify picture`;
export const modifyPicture = (param, callback) => {
	return dispatch => {
		API.modifyPictureAPI(param).then(res => {
			dispatch(modifyPictureSuccess(res.data));
			callback && callback();
		}, err => {
			console.log(err)
		})
	}
}
const modifyPictureSuccess = (result) => {
	return {
		type: MODIFY_PICTURE,
		payload: result
	}
}

// 插画审核通过
export const PICTURE_PASS = `${page} picture pass`;
export const picturePass = (param, callback) => {
	return dispatch => {
		API.picturePassAPI(param).then(res => {
			dispatch(picturePassSuccess(res.data));
			callback && callback();
		}, err => {
			console.log(err)
		})
	}
}
const picturePassSuccess = (result) => {
	return {
		type: PICTURE_PASS,
		payload: {
			positionDetail: result
		}
	}
}

// 插画返工
export const PUCTURE_REWORK = `${page} pucture reword`;
export const pictureRework = (param, callback, error) => {
	return dispatch => {
		API.pictureReworkAPI(param).then(res => {
			dispatch(pictureReworkSuccess(res.data));
			callback && callback();
		}, err => {
			error && error();
		})
	}
}
const pictureReworkSuccess = (result) => {
	return {
		type: PUCTURE_REWORK,
		payload: {
			positionDetail: result
		}
	}
}

// 标记修改
export const SIGN_MODIFY = `${page} sign modify`;
export const signModyfy = (param, callback) => {
	return dispatch => {
		API.signModyfyAPI(param).then(res => {
			dispatch(signModyfySuccess(res.data));
			callback && callback();
		}, err => {
			console.log(err)
		})
	}
}
const signModyfySuccess = (result) => {
	return {
		type: SIGN_MODIFY,
		payload: result
	}
}

// 标记返工
export const SIGN_REWORK = `${page} sign reword`; 
export const signRework = (param, callback, error) => {
	return dispatch => {
		API.signReworkAPI(param).then(res => {
			dispatch(signReworkSuccess(res.data));
			callback && callback();
		}, err => {
			error && error();
		})
	}
}
const signReworkSuccess = (result) => {
	return {
		type: SIGN_REWORK,
		payload: result
	}
}

// 标记通过
export const SIGN_PASS = `${page} sign pass`;
export const signPass = (param, callback) => {
	return dispatch => {
		API.signPassAPI(param).then(res => {
			dispatch(signPassSuccess(res.data));
			callback && callback();
		}, err => {
			console.log(err)
		})
	}
}
const signPassSuccess = (result) => {
	return {
		type: SIGN_PASS,
		payload: result
	}
}

 // 标记题目
export const SIGN_TITLE = `${page} sign title`;
export const signTitle = (param, callback) => {
	return dispatch => {
		API.signTitleAPI(param).then(res => {
			dispatch(signTitleSuccess(res.data));
			callback && callback();
		}, err => {
			console.log(err)
		})
	}
}
const signTitleSuccess = (result) => {
	return {
		type: SIGN_TITLE,
		payload: result
	}
}

 // 题目详情
export const TITLE_DETAIL = `${page} title detail`;
export const TITLE_DETAIL_ERR = `${page} title detail failure`;
export const getTitleDetail = (param, callback) => {
	return (dispatch) => {
		API.getTitleDetailAPI(param).then(res => {
			dispatch(getTitleDetailSuccess(res.data));
			callback && callback();
		}, err => {
			dispatch(getTitleDetailError());
		})
	}
}
const getTitleDetailSuccess = (result) => {
	return {
		type: TITLE_DETAIL,
		payload: {
			titleDetail: result
		}
	}
}
const getTitleDetailError = () => {
	return {
		type: TITLE_DETAIL_ERR,
		payload: {
			titleDetail: []
		}
	}
}




// WEBPACK FOOTER //
// ./src/entry_app/question_manage/image_correction/action.js